import { css } from '@emotion/react'
import type { SerializedStyles } from '@emotion/serialize'
import { forwardRef, memo, ReactNode } from 'react'
import { getThemeSpacing } from '../../styles/appTheme'
import { greenMFC, PAPER_HEIGHTS } from '../../theme'

const staticStyles = css({
    animation: 'unset',
    color: greenMFC,
    padding: getThemeSpacing(3),
    textAlign: 'center',
    fontSize: 11,
    fontWeight: 'bold',
    lineHeight: '12px',
    zIndex: PAPER_HEIGHTS.base,
})

const compactStyles = css({
    padding: 15,
})

type PosterProps = {
    children?: ReactNode
    compact?: boolean
    hiddenShow?: boolean
    styleOverrides?: SerializedStyles
}

const Poster = memo(
    forwardRef<HTMLDivElement, PosterProps>((props, ref) => {
        const { children, compact, hiddenShow, styleOverrides } = props
        const styles = css([
            ...[staticStyles],
            ...(compact ? [compactStyles] : []),
            ...(styleOverrides ? [styleOverrides] : []),
        ])
        const testId = `Image__Model${hiddenShow ? 'Show' : ''}Status`
        return (
            <div ref={ref} css={styles} data-testid={testId}>
                {children}
            </div>
        )
    }),
)

export default Poster
